import { ImpactType, ImpactTile, Tile, TileVariant } from '..';
import { CarbonOffsetType } from '../carbon-offsets';
import { CarbonRemovalType } from '../carbon-removal';
import { HabitatRestorationType } from '../habitat-restoration';
import { PublicProjectSummary } from '../projects';
import { SubProfileTileType, TreeType } from '../tree';

export const isCarbonOffsetType = (tile: ImpactTile, project?: PublicProjectSummary): tile is CarbonOffsetType =>
  tile.projectId === project?.id && project?.impactType === ImpactType.CARBON_OFFSETS;

export const isCarbonRemovalType = (tile: ImpactTile, project?: PublicProjectSummary): tile is CarbonRemovalType =>
  tile.projectId === project?.id && project?.impactType === ImpactType.CARBON_REMOVAL;

export const isHabitatRestorationType = (tile: ImpactTile): tile is HabitatRestorationType => 'numberOfMeters' in tile;

export const isTreeType = (tile: Tile): tile is TreeType => 'value' in tile && typeof tile.value === 'number';

export const isSubProfileType = (tile: Tile): tile is SubProfileTileType => tile.variant === TileVariant.SUBPROFILE;

export const isImpactTile = (tile: Tile): tile is ImpactTile => 'projectId' in tile;
